import { jsx as _jsx } from "react/jsx-runtime";
import angleLeftIcon from '@/core/svg/tailwind/angle-left.svg';
import angleRightIcon from '@/core/svg/tailwind/angle-right.svg';
import { SvgIcon } from '@/core/ui/SvgIcon';
import { NavIconButton } from './NavButton.styled';
const NavButton = ({ icon, onClick }) => (_jsx(NavIconButton, { disableRipple: true, onClick: onClick, children: _jsx(SvgIcon, { icon: icon === 'prev' ? angleLeftIcon : angleRightIcon, size: "3xl" }) }));
export { NavButton };
